import React, { useState, useEffect } from 'react';
import Calendar from 'react-awesome-calendar';
import { sample } from 'lodash';
import { get } from 'axios';
import config from '../../../../config';
import { FaSquare } from 'react-icons/fa';

const ViewCalender = props => {
  const [events, setevents] = useState([]);
  let colors = ['#fd3153', '#1ccb9e', '#FFB3B3', '#9BDDF2', '#3694DF', '#D0A2FB'];
  let tokenKey = {
    headers: { Authorization: 'Token ' + sessionStorage.getItem('tokenKey') },
  };

  useEffect(() => {
    let bookingEvents = [];
    props.data.forEach(obj => {
      bookingEvents.push({
        id: obj.id,
        color: sample(colors),
        from: obj.booking_from,
        to: obj.booking_to,
        title: obj.function_type,
      });
    });

    const currentYear = new Date().getFullYear();
    get(
      config.service + `/booking/muhurtham_calendar?state=Tamilnadu&year=${currentYear}`,
      tokenKey
    )
      .then(response => {
        const allEvents = [...bookingEvents];
        if (response.data.data && response.data.data.length > 0) {
          const valarDates = response.data.data[0].valarpirai_dates || [];
          const theiDates = response.data.data[0].theipirai_dates || [];

          valarDates.forEach((date, idx) => {
            allEvents.push({
              id: `valar_${idx}`,
              color: '#9c27b0',
              from: `${date}T00:00:00+00:00`,
              to: `${date}T23:59:59+00:00`,
              title: 'Valarpirai Muhurtham',
            });
          });

          theiDates.forEach((date, idx) => {
            allEvents.push({
              id: `thei_${idx}`,
              color: '#2196f3',
              from: `${date}T00:00:00+00:00`,
              to: `${date}T23:59:59+00:00`,
              title: 'Theipirai Muhurtham',
            });
          });
        }
        setevents(allEvents);
      })
      .catch(() => {
        setevents(bookingEvents);
      });
  }, []);

  return (
    <div>
      <Calendar events={events} />
      <div style={{ display: 'flex', gap: '20px', fontSize: '13px', padding: '10px 16px', flexWrap: 'wrap', alignItems: 'center' }}>
        <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
          <FaSquare color="#9c27b0" /> Valarpirai Muhurtham
        </span>
        <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
          <FaSquare color="#2196f3" /> Theipirai Muhurtham
        </span>
      </div>
    </div>
  );
};

export default ViewCalender;
